import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { generateNamingConventions } from '../services/tracking';

export default function ReferralSplashPage(props) {
  const navigate = useNavigate();
  
  const handleSubmit = e => {
    e.preventDefault();
    const isReferral = true;
    const adInformation = generateNamingConventions({ isReferral });
    props.handleSetState({
        isReferral,
        type: 'referral',
        adInformation
    });
    navigate(`/${adInformation || '0'}/user`);
  }

  return (
    <div>
        <div className="container landingRW d-flex align-items-center justify-content-center contentBox containerLanding">
        <div className="center text-center">
            <h4 className="landingUpdate">REFERRAL</h4>
            <h3>Has your customer referred a friend or a second house for themselves?</h3>
            <button
                className="btnLndng btn btn-primary top"
                onClick={handleSubmit}
            >
                Yes
            </button>
        </div>
        </div>
    </div>
  );
}
